import { EmptyState } from '@/components/ui/EmptyState';

export function DocumentsTab() {
  return <EmptyState message='Раздел документов в разработке' />;
}
